import * as React from 'react';

function QuoteMark(props) {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<svg width="63" height="48" viewBox="0 0 63 48" fill="none" selfAlign="baseline" xmlns="http://www.w3.org/2000/svg">
     <path opacity="0.15" d="M24.574 0C27.3536 0 29.2858 2.76519 28.3301 5.37535L13.6836 45.3753C13.1064 46.9518 11.6063 48 9.9275 48H4.04356C1.49395 48 -0.404944 45.6467 0.133893 43.1546L8.78291 3.15464C9.18094 1.31381 10.8092 0 12.6925 0H24.574ZM58.3703 0C61.1476 0 63.0797 2.76084 62.1284 5.37011L47.545 45.3701C46.9693 46.9492 45.4678 48 43.787 48H37.9072C35.3576 48 33.4587 45.6467 33.9975 43.1546L42.6465 3.15464C43.0446 1.31381 44.6728 0 46.5562 0H58.3703Z" fill="white"/>     </svg>
	);
}

export default QuoteMark;